import { computed } from 'mobx';
import { IsNotEmpty,IsNumberString, IsDefined } from 'class-validator';

import { EntityModel } from 'src/core/services/data/models';
import { factory, OData, $data } from 'src/core/services/data/JayDataContext';
import { ContextService } from 'src/core/services/context.service';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';
import { FormatService } from 'src/core/services/format.service';

export class AllotmentRangeDailyListDataService extends DataService<typeof Model.Products.Logic.ViewModels.AllotmentRangeDailyItem, Model.Products.Logic.ViewModels.AllotmentRangeDailyItem, AllotmentRangeDailyItem> {
	private id = -1;

	constructor(contextService: ContextService, entitySet: (context: OData.Container) => $data.EntitySet<typeof Model.Products.Logic.ViewModels.AllotmentRangeDailyItem, Model.Products.Logic.ViewModels.AllotmentRangeDailyItem>, private formatService: FormatService) {
		super(contextService, entitySet);
	}

	protected map(entity: Model.Products.Logic.ViewModels.AllotmentRangeDailyItem): AllotmentRangeDailyItem {
		return new AllotmentRangeDailyItemModel(entity, this.formatService);
	}

	public static make(context?: any, formatService?: FormatService): AllotmentRangeDailyListDataService {
		return new AllotmentRangeDailyListDataService(context, ctx => ctx.AllotmentRangeDailies, formatService);
	}

	add(dailyLimint: number, allotmentRangeId: number, day: number, date: Date) {
		const entity = new Model.Products.Logic.ViewModels.AllotmentRangeDailyItem();
		entity.allotmentRangeId = allotmentRangeId;
		entity.dailyLimit = dailyLimint;
		entity.day = day;
		entity.date = date;
		entity.id = this.id--;

		return this.create(() => entity);
	}
}

export class AllotmentRangeDailyItemModel extends EntityModel<Model.Products.Logic.ViewModels.AllotmentRangeDailyItem, AllotmentRangeDailyItem> implements AllotmentRangeDailyItem {
	@property<AllotmentRangeDailyItemModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<AllotmentRangeDailyItemModel>(o => o.entity.allotmentRangeId, (o, value) => o.entity.allotmentRangeId = value)
	public allotmentRangeId: number;

	@property<AllotmentRangeDailyItemModel>(o => o.entity.dailyLimit, (o, value) => o.entity.dailyLimit = value)
	@IsDefined({ message: 'daily limit is required' })
	// @IsNumberString({ message: 'daily limit is number' })
	public dailyLimit: number;

	@property<AllotmentRangeDailyItemModel>(o => o.entity.day, (o, value) => o.entity.day = value)
	public day: number;

	@property<AllotmentRangeDailyItemModel>(o => o.entity.allotmentRange, (o, value) => o.entity.allotmentRange = value)
	public allotmentRange: any;

	@property<AllotmentRangeDailyItemModel>(o => o.entity.date, (o, value) => o.entity.date = value)
	public date: Date;

	@computed
	public get dateText(): string {
		return this.formatService.toString('date', this.date, "utc");
	}

	constructor(entity: Model.Products.Logic.ViewModels.AllotmentRangeDailyItem, private formatService: FormatService) {
		super(entity);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/allotment-range-daily/list/allotment-range-daily-list.data.ts